import TopLevelDomainsFilter from "../../components/filters/TopLevelDomainsFilter/TopLevelDomainsFilter";
import TopLevelDomainsFilterResult from "../../components/filters/TopLevelDomainsFilter/TopLevelDomainsFilterResult";
import { leadsFilterApiCategory } from "../../types/leadsFilterApiCategory";
import { leadsFilterCategoryMap } from "../../types/leadsFilterCategory";
import { defineDescriptionFilter } from "../defineSourcedFilter";

import FindTopLevelDomainsFilter from "./TopLevelDomainsFilter";

export const topLevelDomainDefinition = defineDescriptionFilter({
    key: "topLevelDomain",
    apiCategory: leadsFilterApiCategory.topLevelDomain,
    category: leadsFilterCategoryMap.website,
    trackingName: "Top Level Domains",
    titleKey: { key: "si.lead_gen_filters.group.topLevelDomains.name" },

    render: ({ description }) => ({
        tooltipText: { key: "si.lead_gen_filters.group.topLevelDomain.tooltip" },
        filter: new FindTopLevelDomainsFilter({
            options: description.topLevelDomain.options,
        }),
        filterView: TopLevelDomainsFilter,
        filterResultView: TopLevelDomainsFilterResult,
    }),
});
